// Wiki-only long-form descriptions for each tech node. The in-game card on
// the wiki tier pages is rendered from the shared research/tree.ts data
// (single source of truth with main.ts); this map is the description shown
// next to it.
//
// Editorial rules:
//   1. Describe WHAT the tech does mechanically. Don't describe WHEN or WHY
//      to pick it. No "strong into X", "use when Y", "don't over-build" —
//      those are meta opinions and writing them here makes them official.
//      Players discover the meta themselves.
//   2. Don't address the player as "you / your". Use "the lane", "the
//      roster", "the first anti-air tower" instead of "your lane",
//      "your roster", "your first anti-air tower". Wiki copy is reference
//      material, not coaching.

export const TECH_DETAILS: Record<string, string> = {
  t1_b1_cannon:
    "Unlocks the Cannon — the first area-of-effect tower.",

  t1_b2_u4:
    "Pick one of two reinforcements to add to the sendable roster. Permanent choice.\n\n**Elder** is a single heavy body.\n\n**Footmen** is a squad of three lighter bodies.",

  t3_b1_lane_expansion:
    "Adds more buildable rows at the back of the lane. This technology can be researched multiple times.",

  t2_b3_harpoon:
    "Unlocks the Harpoon — the first anti-air tower.",

  t2_b2_u4:
    "Pick one of two reinforcements to add to the sendable roster. Permanent choice.\n\n**Juggernaut** is a single colossal body.\n\n**Raider** is a single body that attacks towers.",

  t2_b1_airmount:
    "Substitutes Lancer with a flying version.",
};
